export default __webpack_public_path__ + "static/media/spring.d333f33c.svg";